const ApplicationVendorQuestionnaireSteps = {
  VENDOR_INFO: 'Vendor Info',
  BUSINESS_PROFILE: 'Business Profile',
  RELATIONSHIP_HISTORY: 'Relationship History',
  COMPLIANCE: 'Compliance',
  FACTORY_PROFILES: 'Factory Profiles',
  OTHER_PRODUCTION_FACILITIES: 'Other Production Facilities',
  GARMENT_PRODUCTION: 'Garment Production',
  ADDITIONAL_CAPABILITIES: 'Additional Capabilities',
  FASHION_NOVA_APPROVAL: 'Fashion Nova Approval',
  BUYER_DETAILS: 'Buyer Details',
  SPONSOR_AND_EXEC_APPROVAL: 'Sponsor and Executive Approval',
};

const ApplicationBuyerQuestionnaireStepsLabels = {
  [ApplicationVendorQuestionnaireSteps.VENDOR_INFO]: 'Vendor Information',
  [ApplicationVendorQuestionnaireSteps.BUSINESS_PROFILE]: 'Business Profile',
  [ApplicationVendorQuestionnaireSteps.RELATIONSHIP_HISTORY]:
    'Relationship History',
  [ApplicationVendorQuestionnaireSteps.COMPLIANCE]:
    'Compliance & Quality Assurance',
  [ApplicationVendorQuestionnaireSteps.FACTORY_PROFILES]: 'Factory Profiles',
  [ApplicationVendorQuestionnaireSteps.ADDITIONAL_CAPABILITIES]:
    'Vendor Capabilities',
  [ApplicationVendorQuestionnaireSteps.FASHION_NOVA_APPROVAL]:
    'Fashion Nova Approval',
  [ApplicationVendorQuestionnaireSteps.BUYER_DETAILS]: 'Buyer Questionnaire',
  [ApplicationVendorQuestionnaireSteps.SPONSOR_AND_EXEC_APPROVAL]:
    'Sponsor and Executive Approval',
};

const VendorMerchTypes = {
  DIRECT_FACTORY: 'Direct', // Displayed "Direct Factory / Manufacturer" on the front-end
  IMPORTER: '3rd Party', // Displayed "Importer / Wholesaler" on the front-end
  AGENT: 'Hybrid', // Displayed "Agent" on the front-end
};

const VendorQuestionnaireSteps = {
  [VendorMerchTypes.IMPORTER]: [
    ApplicationVendorQuestionnaireSteps.VENDOR_INFO,
    ApplicationVendorQuestionnaireSteps.BUSINESS_PROFILE,
    ApplicationVendorQuestionnaireSteps.RELATIONSHIP_HISTORY,
    ApplicationVendorQuestionnaireSteps.COMPLIANCE,
  ],
  [VendorMerchTypes.DIRECT_FACTORY]: [
    ApplicationVendorQuestionnaireSteps.VENDOR_INFO,
    ApplicationVendorQuestionnaireSteps.BUSINESS_PROFILE,
    ApplicationVendorQuestionnaireSteps.RELATIONSHIP_HISTORY,
    ApplicationVendorQuestionnaireSteps.COMPLIANCE,
    ApplicationVendorQuestionnaireSteps.ADDITIONAL_CAPABILITIES,
    ApplicationVendorQuestionnaireSteps.FACTORY_PROFILES,
  ],
  [VendorMerchTypes.AGENT]: [
    ApplicationVendorQuestionnaireSteps.VENDOR_INFO,
    ApplicationVendorQuestionnaireSteps.BUSINESS_PROFILE,
    ApplicationVendorQuestionnaireSteps.RELATIONSHIP_HISTORY,
    ApplicationVendorQuestionnaireSteps.COMPLIANCE,
    ApplicationVendorQuestionnaireSteps.ADDITIONAL_CAPABILITIES,
    ApplicationVendorQuestionnaireSteps.FACTORY_PROFILES,
  ],
};

const ApplicationStatus = {
  INITIATED: 'Initiated',
  VENDOR_QUESTIONNAIRE: 'VendorQuestionnaire',
  BUYER_QUESTIONNAIRE: 'BuyerQuestionnaire',
  SPONSOR_APPROVAL: 'SponsorApproval',
  SPONSOR_DENIED: 'SponsorDenied',
  FIRST_EXECUTIVE_APPROVAL: 'FirstExecutiveApproval',
  FIRST_EXECUTIVE_DENIED: 'FirstExecutiveDenied',
  SECOND_EXECUTIVE_APPROVAL: 'SecondExecutiveApproval',
  SECOND_EXECUTIVE_DENIED: 'SecondExecutiveDenied',
  PRE_ONBOARDING: 'PreOnboarding',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  DENIED: 'Denied',
};

export default ApplicationVendorQuestionnaireSteps;

export {
  ApplicationVendorQuestionnaireSteps,
  ApplicationBuyerQuestionnaireStepsLabels,
  VendorMerchTypes,
  VendorQuestionnaireSteps,
  ApplicationStatus,
};
